import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  PropositionJockeyNameStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryResultsStyled,
  PropositionTrainerNameStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'

type Props = {
  summary: FieldSummary
}

export const TrotFieldSummaryResults: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryResultsStyled>
      <SelectionFormTableStyled>
        <PropositionJockeyNameStyled>
          <PropositionStrongFieldsStyled>D:</PropositionStrongFieldsStyled>
          <span className={summary.isRiderChanged ? 'rider-change fg-gray-lightest' : ''}>
            {summary.jockeyName ? toTitleCase(summary.jockeyName) : summary.jockeyName}
          </span>
        </PropositionJockeyNameStyled>

        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>
            {summary.trainerName ? toTitleCase(summary.trainerName) : summary.trainerName}
          </span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryResultsStyled>
  )
}
